export const SocketEvents = {
    MESSAGE_NEW: 'message:new',
    MESSAGE_EDIT: 'message:edit',
    MESSAGE_DELETE: 'message:delete',
    TYPING_START: 'typing:start',
    TYPING_STOP: 'typing:stop',
    PRESENCE_UPDATE: 'presence:update',
    CHANNEL_JOIN: 'channel:join',
    CHANNEL_LEAVE: 'channel:leave',
    CHANNEL_UPDATE: 'channel:update',
    CHANNEL_DELETE: 'channel:delete',
    REACTION_ADD: 'reaction:add',
    REACTION_REMOVE: 'reaction:remove',
    USER_STATUS: 'user:status',
    CHANNEL_KEY_ROTATION_NEEDED: 'channel:key-rotation-needed',
    CHANNEL_KEY_ROTATED: 'channel:key-rotated',
    TODO_LIST_CHANGED: 'todo:list-changed',
    ERROR: 'error',
};
//# sourceMappingURL=events.js.map